import { createFileRoute } from "@tanstack/react-router";
import { m } from "~/lib/i18n";

export const Route = createFileRoute("/_app/boosted-limit-orders")({
  head: () => ({
    meta: [
      { title: m.earn_accumulator_page_meta_title() },
      {
        content: m.earn_accumulator_page_meta_description(),
        name: "description",
      },
    ],
  }),
});
